const API_BASE = process.env.REACT_APP_API_URL || '';

export async function createExportJob(orgId, type, config = {}) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/export-jobs/${type}`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify(config)
  });
  
  if (!response.ok) {
    throw new Error('Failed to create export job');
  }
  
  const data = await response.json();
  return data.job;
}

export async function getExportJobs(orgId, filters = {}) {
  const params = new URLSearchParams();
  if (filters.type) params.append('type', filters.type);
  if (filters.status) params.append('status', filters.status);
  if (filters.limit) params.append('limit', filters.limit.toString());
  
  const queryString = params.toString();
  const url = `${API_BASE}/orgs/${orgId}/export-jobs${queryString ? '?' + queryString : ''}`;
  
  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch export jobs');
  }
  
  const data = await response.json();
  return data.jobs;
}

export async function getExportJob(orgId, jobId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/export-jobs/${jobId}`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch export job');
  }
  
  const data = await response.json();
  return data.job;
}

export async function getExportJobStatus(orgId, jobId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/export-jobs/${jobId}/status`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch export job status');
  }
  
  return response.json();
}

export async function cancelExportJob(orgId, jobId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/export-jobs/${jobId}/cancel`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to cancel export job');
  }
  
  const data = await response.json();
  return data.job;
}

export async function getExportArtifact(orgId, artifactId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/export-artifacts/${artifactId}`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch export artifact');
  }
  
  const data = await response.json();
  return data.artifact;
}

export async function downloadExportArtifact(orgId, artifactId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/export-artifacts/${artifactId}/download`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to download export artifact');
  }
  
  return response.json();
}
